import { Editor, Element, Transforms } from "slate";
import { deserializeHTMLString } from "../../utilities/slateSerialize";
export const withHtml = (editor) => {
    const { isInline, isVoid } = editor;
    editor.isInline = (element) => (element.type === "link" ? true : isInline(element));
    editor.isVoid = (element) => (element.type === "image" ? true : isVoid(element));
    editor.insertData = (data) => {
        if (!editor.insertFragmentData(data)) {
            const html = data.getData("text/html");
            if (html) {
                const htmlWithoutComments = html.replace(/<!--.*?-->/gm, "");
                const fragments = deserializeHTMLString(htmlWithoutComments);
                if (!Array.isArray(fragments)) {
                    throw new TypeError(`Unexpected fragments is not an array`);
                }
                const cleanFragments = (slateNode) => {
                    if ("text" in slateNode && slateNode.text === "") {
                        return false;
                    }
                    if (Element.isElement(slateNode) && slateNode.children) {
                        slateNode.children = slateNode.children.filter((child) => {
                            if ("text" in child && child.text === "") {
                                return false;
                            }
                            return true;
                        });
                        slateNode.children.forEach(cleanFragments);
                    }
                    return true;
                };
                fragments.forEach(cleanFragments);
                // https://github.com/ianstormtaylor/slate/issues/4857
                try {
                    Transforms.insertFragment(editor, fragments);
                }
                catch (e) {
                    console.error(`Error inserting data`, e);
                }
                // removes empty spans, etc.
                Editor.normalize(editor);
            }
            else {
                /* Paste Plain Text */
                const text = data.getData("text/plain");
                editor.insertText(text);
                Editor.normalize(editor);
            }
        }
    };
    return editor;
};
